import React from 'react';
import AndieGenericToolRender from './AndieGenericToolRender';
import { useTranslation } from 'react-i18next';
import { ActionRenderAi } from '@/ai/types/action-render-ai';
import { ExploreRounded } from '@mui/icons-material';

type ActionResponse = { routes?: Array<{ path: string; label: string }> };

export type AndieGetAvailableRoutesProps = ActionRenderAi<ActionResponse>;

const AndieGetAvailableRoutes = (props: AndieGetAvailableRoutesProps) => {
    const { t } = useTranslation();
    return (
        <AndieGenericToolRender<ActionResponse>
            title={() => t('andie.tool.get-available-routes.title')}
            icon={<ExploreRounded fontSize="small" />}
            loadingMessages={() => [t('andie.tool.get-available-routes.loading')]}
            completeMessage={({ result }) =>
                t('andie.tool.get-available-routes.complete', {
                    value: Array.isArray(result?.routes) ? result.routes.length : 0,
                })
            }
            {...props}
        />
    );
};

export default AndieGetAvailableRoutes;
